import {
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
} from "@mui/material";
import { Paper } from "@mui/material";
import React from "react";
import { formatDate, formatText } from "../../../utils/utils";
import {
  deletedTableHeaderStyles,
  deletedTableRowStyles,
} from "../../../utils/styles";

const DeletedIncomeDetails = ({
  deletedIncomeDetails,
  incomeType,
}: {
  deletedIncomeDetails: any;
  incomeType: string;
}) => {
  console.log(incomeType);
  const fixed = incomeType === "fixed";
  const perkm = incomeType === "perkm";
  const fixedAndPerkm = fixed || perkm;

  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow style={deletedTableRowStyles}>
            <TableCell style={deletedTableHeaderStyles}>Income Type</TableCell>
            <TableCell style={deletedTableHeaderStyles}>Amount</TableCell>
            <TableCell style={deletedTableHeaderStyles}>Limit</TableCell>
            <TableCell style={deletedTableHeaderStyles}>Rate</TableCell>
            <TableCell style={deletedTableHeaderStyles}>
              Over Limit Rate
            </TableCell>
            <TableCell style={deletedTableHeaderStyles}>GST</TableCell>
            <TableCell style={deletedTableHeaderStyles}>Remarks</TableCell>
            <TableCell style={deletedTableHeaderStyles}>Updated On</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {deletedIncomeDetails.map((income: any) => (
            <TableRow key={income?.id} style={deletedTableRowStyles}>
              <TableCell style={deletedTableHeaderStyles}>
                {formatText(income?.incomeType)}
              </TableCell>
              <TableCell style={deletedTableHeaderStyles}>
                {income?.amount || "-"}
              </TableCell>
              <TableCell style={deletedTableHeaderStyles}>
                {income?.limit || "-"}
              </TableCell>
              <TableCell style={deletedTableHeaderStyles}>
                {income?.rate || "-"}
              </TableCell>
              <TableCell style={deletedTableHeaderStyles}>
                {income?.overLimitRate || "-"}
              </TableCell>
              <TableCell style={deletedTableHeaderStyles}>
                {income?.gstPercentage || "-"}
              </TableCell>
              <TableCell style={deletedTableHeaderStyles}>
                {income?.remarks || "-"}
              </TableCell>
              <TableCell style={deletedTableHeaderStyles}>
                {formatDate(income?.createdAt)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DeletedIncomeDetails;
